import React from "react";
import Util from "../../Util";
import Nav from "../../Components/Nav";
import Footer from "../../Components/Footer";
import style from "./Style.module.css";
import { Container, Hidden, Visible } from "react-grid-system";
import { withAlert } from "react-alert";
import { withRouter } from "react-router-dom";
import SheetCard from "../../Components/SheetCard";
import ShowReview from "../../Components/ShowReview";
import ShowReport from "../../Components/ShowReport";

class Sell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: {
        user: {
          infoEnter: true,
        },
        store: [],
      },
      sheets: {
        verf: [],
        unverf: [],
      },
      verfFil: [],
      filter: {
        search: "",
        sem: "any",
        year: "0",
      },
      storeMap: {},
      showReview: false,
      reviewID: "",
      reviewName: "",
      review: {
        before: false,
        score: 0,
        message: "",
      },
      showReport: false,
      reportID: "",
      reportName: "",
      report: {
        category: "ชีทอ่านไม่รู้เรื่อง",
        message: "",
      },
    };
  }

  async componentDidMount() {
    var data = await Util.sendPost("/api/user/getMySheet", {});
    if (data.success) {
      this.setState({ data: data.data });
      var map = {};
      for (var i = 0; i < data.data.store.length; i++)
        map[data.data.store[i].code] = {
          color: data.data.store[i].color,
          short: data.data.store[i].short,
        };
      this.setState({ storeMap: map });
      this.reloadSheets();
    } else this.props.history.push("/");
  }

  render() {
    const lang = Util.getLang();
    return (
      <React.Fragment>
        <div className={style.shopPage}>
          <ShowReview
            showReview={this.state.showReview}
            review={{
              reviewID: this.state.reviewID,
              reviewName: this.state.reviewName,
              review: this.state.review,
            }}
            onClose={() => {
              this.setState({ showReview: false });
            }}
          />

          <ShowReport
            showReport={this.state.showReport}
            reportID={this.state.reportID}
            report={this.state.report}
            reportName={this.state.reportName}
            onClose={() => {
              this.setState({ showReport: false });
            }}
          />

          <Nav current="shop" user={this.state.data.user} />
          <Container>
            <div className={style.blanker} />
            <div className={style.bigHeader}>ชีทที่ซื้อไว้</div>
            <div className={style.buyID}>
              {"รหัสผู้ซื้อ : " + this.state.data.user.facebookID}
            </div>
            <hr />
            <div className={style.reject}>
              <div className={style.rejectHeader}>ประกาศ</div>
              <div className={style.rejectReason}>
                ห้ามส่งต่อหรือถ่ายเอกสารชีทสรุป
                เพื่อเป็นการให้เกียรติแก่ผู้เขียน
              </div>
            </div>

            <Visible xs sm>
              <div className={style.barMobile + " " + style.searcher}>
                <input
                  type="text"
                  placeholder={"ค้นหาตามชื่อ"}
                  className={style.search + " " + style.mobile}
                  value={this.state.filter.search}
                  onChange={(event) =>
                    this.setFilter("search", event.currentTarget.value)
                  }
                />
              </div>
              <div className={style.barMobile + " " + style.filter}>
                <select
                  className={style.semSelector + " " + style.mobile}
                  value={this.state.filter.sem}
                  onChange={(event) =>
                    this.setFilter("sem", event.currentTarget.value)
                  }
                >
                  {this.genTermOptions(lang)}
                </select>
                <select
                  className={
                    style.semSelector + " " + style.mobile + " " + style.last
                  }
                  value={this.state.filter.year}
                  onChange={(event) =>
                    this.setFilter("year", event.currentTarget.value)
                  }
                >
                  {this.genYearOptions(lang)}
                </select>
              </div>
            </Visible>
            <Hidden xs sm>
              <div className={style.filterBar}>
                <input
                  type="text"
                  placeholder={"ค้นหาตามชื่อ"}
                  className={style.search}
                  value={this.state.filter.search}
                  onChange={(event) =>
                    this.setFilter("search", event.currentTarget.value)
                  }
                />
                <select
                  className={style.semSelector}
                  value={this.state.filter.sem}
                  onChange={(event) =>
                    this.setFilter("sem", event.currentTarget.value)
                  }
                >
                  {this.genTermOptions(lang)}
                </select>
                <select
                  className={style.semSelector}
                  value={this.state.filter.year}
                  onChange={(event) =>
                    this.setFilter("year", event.currentTarget.value)
                  }
                >
                  {this.genYearOptions(lang)}
                </select>
              </div>
            </Hidden>
            <div className={style.sheetWrapper}>{this.renderVerf()}</div>
          </Container>
        </div>
        <Footer />
      </React.Fragment>
    );
  }

  setRev = (field, value) => {
    var x = this.state.review;
    x[field] = value;
    this.setState({ review: x });
  };

  setRep = (field, value) => {
    var x = this.state.report;
    x[field] = value;
    this.setState({ report: x });
  };

  reloadSheets = async () => {
    var data = await Util.sendPost("/api/user/getMyallSheet", {});
    var allSheets = { verf: [] };
    for (var i = 0; i < data.data.sheets.length; i++) {
      var sheet = data.data.sheets[i];
      var realsheet = sheet.sheet;
      if (realsheet) {
        realsheet.created = sheet.created;
        allSheets.verf.push(realsheet);
      }
    }
    await this.setState({ sheets: allSheets });
    await this.goFilter();
  };

  renderVerf = () => {
    if (this.state.verfFil.length === 0)
      return <div className={style.nothing}>ไม่พบรายการ</div>;
    return this.state.verfFil.map((sheet, index) => {
      return (
        <SheetCard
          sheet={sheet}
          key={sheet._id}
          bought
          color={sheet.color}
          index={index}
        />
      );
    });
  };

  genTermOptions = () => {
    const ops = [
      { label: "any", value: "any" },
      { label: "1", value: 1 },
      { label: "2", value: 2 },
      { label: "3", value: 3 },
    ];
    return ops.map(({ label, value }) => (
      <option
        label={label === "any" ? "ทุกเทอม" : label}
        value={value}
        key={value}
      >
        {label === "any" ? "ทุกเทอม" : label}
      </option>
    ));
  };

  genYearOptions = () => {
    var ops = [0];
    var curr = new Date().getFullYear();
    for (var i = 0; i < 10; i++) ops.push(curr - i);
    return ops.map((y) => (
      <option label={y === 0 ? "ทุกปี" : y} value={y} key={y}>
        {y === 0 ? "ทุกปี" : y}
      </option>
    ));
  };

  setFilter = async (field, val) => {
    var x = this.state.filter;
    x[field] = val;
    await this.setState({ filter: x });
    await this.goFilter();
  };

  goFilter = async () => {
    var res = [];
    var hi = this.state.filter.search.trim().toLowerCase();
    for (var i = 0; i < this.state.sheets.verf.length; i++) {
      var sheet = this.state.sheets.verf[i];
      if (
        this.state.filter.sem !== "any" &&
        parseInt(this.state.filter.sem) !== sheet.semester
      )
        continue;
      if (
        this.state.filter.year !== "0" &&
        parseInt(this.state.filter.year) !== sheet.year
      )
        continue;
      if (
        this.state.filter.search.trim() !== "" &&
        !sheet.name.toLowerCase().includes(hi)
      )
        continue;
      sheet.created = new Date(sheet.created).getTime();

      res.push(sheet);
    }

    var sorter = {
      date: function (a, b) {
        return Number(b.created) - Number(a.created);
      },
    };

    res.sort(sorter.date);
    this.setState({ verfFil: res });
  };
}

export default withRouter(withAlert()(Sell));
